// 卡片樣式（card1~4 四選一，作為許願卡背景；id 1紅 2藍 3橙 4綠）
export const CARD_STYLES = [
    { id: 1, image: '/image/wishtree/card1.PNG', image_s: '/image/wishtree/card1_s.PNG' },
    { id: 2, image: '/image/wishtree/card2.PNG', image_s: '/image/wishtree/card2_s.PNG' },
    { id: 3, image: '/image/wishtree/card3.PNG', image_s: '/image/wishtree/card3_s.PNG' },
    { id: 4, image: '/image/wishtree/card4.png', image_s: '/image/wishtree/card4_s.png' },
];

/** 卡片顏色（image_id）決定可掛的層級 ring：紅(1)→1-2、橙(3)→3、藍(2)→4-5、綠(4)→6-7 */
export const RINGS_BY_IMAGE_ID = {
    1: [1, 2],
    3: [3],
    2: [4, 5],
    4: [6, 7],
};

// 樹上掛卡點位
// behind: false＝前方（靜止可見）；true＝後方（公轉時從背面轉到正面，避免半圈空缺）
// x 範圍依 tree.png 各圈金屬環實測寬度校正並均勻分佈，數量較原始版本加密、但保留適度間距
// y 同一圈內一致，維持該圈掛卡整齊對齊
// scale: 統一大小（1）；rotate: 些微角度增加自然感
export const TREE_SLOTS = [
    // 第 1 圈（最上層）— 前方 10
    { id: 1, x: 26.5, y: 9.7, scale: 1, rotate: -5, ring: 1 },
    { id: 2, x: 31.7, y: 9.7, scale: 1, rotate: 4, ring: 1 },
    { id: 3, x: 36.9, y: 9.7, scale: 1, rotate: -3, ring: 1 },
    { id: 4, x: 42.2, y: 9.7, scale: 1, rotate: 5, ring: 1 },
    { id: 5, x: 47.4, y: 9.7, scale: 1, rotate: -4, ring: 1 },
    { id: 6, x: 52.6, y: 9.7, scale: 1, rotate: 3, ring: 1 },
    { id: 7, x: 57.8, y: 9.7, scale: 1, rotate: -5, ring: 1 },
    { id: 8, x: 63.1, y: 9.7, scale: 1, rotate: 4, ring: 1 },
    { id: 9, x: 68.3, y: 9.7, scale: 1, rotate: -3, ring: 1 },
    { id: 10, x: 73.5, y: 9.7, scale: 1, rotate: 5, ring: 1 },
    // 第 1 圈（最上層）— 後方 +8
    { id: 11, x: 29.1, y: 9.7, scale: 1, rotate: 5, ring: 1, behind: true },
    { id: 12, x: 35.1, y: 9.7, scale: 1, rotate: -4, ring: 1, behind: true },
    { id: 13, x: 41.0, y: 9.7, scale: 1, rotate: 3, ring: 1, behind: true },
    { id: 14, x: 47.0, y: 9.7, scale: 1, rotate: -5, ring: 1, behind: true },
    { id: 15, x: 53.0, y: 9.7, scale: 1, rotate: 4, ring: 1, behind: true },
    { id: 16, x: 59.0, y: 9.7, scale: 1, rotate: -3, ring: 1, behind: true },
    { id: 17, x: 64.9, y: 9.7, scale: 1, rotate: 5, ring: 1, behind: true },
    { id: 18, x: 70.9, y: 9.7, scale: 1, rotate: -4, ring: 1, behind: true },

    // 第 2 圈— 前方 14
    { id: 19, x: 19.5, y: 17.6, scale: 1, rotate: -5, ring: 2 },
    { id: 20, x: 24.2, y: 17.6, scale: 1, rotate: 4, ring: 2 },
    { id: 21, x: 28.9, y: 17.6, scale: 1, rotate: -3, ring: 2 },
    { id: 22, x: 33.6, y: 17.6, scale: 1, rotate: 5, ring: 2 },
    { id: 23, x: 38.3, y: 17.6, scale: 1, rotate: -4, ring: 2 },
    { id: 24, x: 43.0, y: 17.6, scale: 1, rotate: 3, ring: 2 },
    { id: 25, x: 47.7, y: 17.6, scale: 1, rotate: -5, ring: 2 },
    { id: 26, x: 52.3, y: 17.6, scale: 1, rotate: 4, ring: 2 },
    { id: 27, x: 57.0, y: 17.6, scale: 1, rotate: -3, ring: 2 },
    { id: 28, x: 61.7, y: 17.6, scale: 1, rotate: 5, ring: 2 },
    { id: 29, x: 66.4, y: 17.6, scale: 1, rotate: -4, ring: 2 },
    { id: 30, x: 71.1, y: 17.6, scale: 1, rotate: 3, ring: 2 },
    { id: 31, x: 75.8, y: 17.6, scale: 1, rotate: -5, ring: 2 },
    { id: 32, x: 80.5, y: 17.6, scale: 1, rotate: 4, ring: 2 },
    // 第 2 圈— 後方 +10
    { id: 33, x: 21.8, y: 17.6, scale: 1, rotate: 5, ring: 2, behind: true },
    { id: 34, x: 28.1, y: 17.6, scale: 1, rotate: -4, ring: 2, behind: true },
    { id: 35, x: 34.4, y: 17.6, scale: 1, rotate: 3, ring: 2, behind: true },
    { id: 36, x: 40.6, y: 17.6, scale: 1, rotate: -5, ring: 2, behind: true },
    { id: 37, x: 46.9, y: 17.6, scale: 1, rotate: 4, ring: 2, behind: true },
    { id: 38, x: 53.1, y: 17.6, scale: 1, rotate: -3, ring: 2, behind: true },
    { id: 39, x: 59.4, y: 17.6, scale: 1, rotate: 5, ring: 2, behind: true },
    { id: 40, x: 65.6, y: 17.6, scale: 1, rotate: -4, ring: 2, behind: true },
    { id: 41, x: 71.9, y: 17.6, scale: 1, rotate: 3, ring: 2, behind: true },
    { id: 42, x: 78.2, y: 17.6, scale: 1, rotate: -5, ring: 2, behind: true },

    // 第 3 圈— 前方 17
    { id: 43, x: 12.0, y: 26.4, scale: 1, rotate: -5, ring: 3 },
    { id: 44, x: 16.8, y: 26.4, scale: 1, rotate: 4, ring: 3 },
    { id: 45, x: 21.5, y: 26.4, scale: 1, rotate: -3, ring: 3 },
    { id: 46, x: 26.2, y: 26.4, scale: 1, rotate: 5, ring: 3 },
    { id: 47, x: 31.0, y: 26.4, scale: 1, rotate: -4, ring: 3 },
    { id: 48, x: 35.8, y: 26.4, scale: 1, rotate: 3, ring: 3 },
    { id: 49, x: 40.5, y: 26.4, scale: 1, rotate: -5, ring: 3 },
    { id: 50, x: 45.2, y: 26.4, scale: 1, rotate: 4, ring: 3 },
    { id: 51, x: 50.0, y: 26.4, scale: 1, rotate: -3, ring: 3 },
    { id: 52, x: 54.8, y: 26.4, scale: 1, rotate: 5, ring: 3 },
    { id: 53, x: 59.5, y: 26.4, scale: 1, rotate: -4, ring: 3 },
    { id: 54, x: 64.2, y: 26.4, scale: 1, rotate: 3, ring: 3 },
    { id: 55, x: 69.0, y: 26.4, scale: 1, rotate: -5, ring: 3 },
    { id: 56, x: 73.8, y: 26.4, scale: 1, rotate: 4, ring: 3 },
    { id: 57, x: 78.5, y: 26.4, scale: 1, rotate: -3, ring: 3 },
    { id: 58, x: 83.2, y: 26.4, scale: 1, rotate: 5, ring: 3 },
    { id: 59, x: 88.0, y: 26.4, scale: 1, rotate: -4, ring: 3 },
    // 第 3 圈— 後方 +13
    { id: 60, x: 14.4, y: 26.4, scale: 1, rotate: 5, ring: 3, behind: true },
    { id: 61, x: 20.3, y: 26.4, scale: 1, rotate: -4, ring: 3, behind: true },
    { id: 62, x: 26.2, y: 26.4, scale: 1, rotate: 3, ring: 3, behind: true },
    { id: 63, x: 32.2, y: 26.4, scale: 1, rotate: -5, ring: 3, behind: true },
    { id: 64, x: 38.1, y: 26.4, scale: 1, rotate: 4, ring: 3, behind: true },
    { id: 65, x: 44.1, y: 26.4, scale: 1, rotate: -3, ring: 3, behind: true },
    { id: 66, x: 50.0, y: 26.4, scale: 1, rotate: 5, ring: 3, behind: true },
    { id: 67, x: 55.9, y: 26.4, scale: 1, rotate: -4, ring: 3, behind: true },
    { id: 68, x: 61.9, y: 26.4, scale: 1, rotate: 3, ring: 3, behind: true },
    { id: 69, x: 67.8, y: 26.4, scale: 1, rotate: -5, ring: 3, behind: true },
    { id: 70, x: 73.8, y: 26.4, scale: 1, rotate: 4, ring: 3, behind: true },
    { id: 71, x: 79.7, y: 26.4, scale: 1, rotate: -3, ring: 3, behind: true },
    { id: 72, x: 85.6, y: 26.4, scale: 1, rotate: 5, ring: 3, behind: true },

    // 第 4 圈— 前方 13
    { id: 73, x: 21.0, y: 34.0, scale: 1, rotate: -5, ring: 4 },
    { id: 74, x: 25.8, y: 34.0, scale: 1, rotate: 4, ring: 4 },
    { id: 75, x: 30.7, y: 34.0, scale: 1, rotate: -3, ring: 4 },
    { id: 76, x: 35.5, y: 34.0, scale: 1, rotate: 5, ring: 4 },
    { id: 77, x: 40.3, y: 34.0, scale: 1, rotate: -4, ring: 4 },
    { id: 78, x: 45.2, y: 34.0, scale: 1, rotate: 3, ring: 4 },
    { id: 79, x: 50.0, y: 34.0, scale: 1, rotate: -5, ring: 4 },
    { id: 80, x: 54.8, y: 34.0, scale: 1, rotate: 4, ring: 4 },
    { id: 81, x: 59.7, y: 34.0, scale: 1, rotate: -3, ring: 4 },
    { id: 82, x: 64.5, y: 34.0, scale: 1, rotate: 5, ring: 4 },
    { id: 83, x: 69.3, y: 34.0, scale: 1, rotate: -4, ring: 4 },
    { id: 84, x: 74.2, y: 34.0, scale: 1, rotate: 3, ring: 4 },
    { id: 85, x: 79.0, y: 34.0, scale: 1, rotate: -5, ring: 4 },
    // 第 4 圈— 後方 +10
    { id: 86, x: 23.4, y: 34.0, scale: 1, rotate: 5, ring: 4, behind: true },
    { id: 87, x: 29.3, y: 34.0, scale: 1, rotate: -4, ring: 4, behind: true },
    { id: 88, x: 35.2, y: 34.0, scale: 1, rotate: 3, ring: 4, behind: true },
    { id: 89, x: 41.1, y: 34.0, scale: 1, rotate: -5, ring: 4, behind: true },
    { id: 90, x: 47.0, y: 34.0, scale: 1, rotate: 4, ring: 4, behind: true },
    { id: 91, x: 53.0, y: 34.0, scale: 1, rotate: -3, ring: 4, behind: true },
    { id: 92, x: 58.9, y: 34.0, scale: 1, rotate: 5, ring: 4, behind: true },
    { id: 93, x: 64.8, y: 34.0, scale: 1, rotate: -4, ring: 4, behind: true },
    { id: 94, x: 70.7, y: 34.0, scale: 1, rotate: 3, ring: 4, behind: true },
    { id: 95, x: 76.6, y: 34.0, scale: 1, rotate: -5, ring: 4, behind: true },

    // 第 5 圈— 前方 9
    { id: 96, x: 27.5, y: 40.7, scale: 1, rotate: -5, ring: 5 },
    { id: 97, x: 33.1, y: 40.7, scale: 1, rotate: 4, ring: 5 },
    { id: 98, x: 38.8, y: 40.7, scale: 1, rotate: -3, ring: 5 },
    { id: 99, x: 44.4, y: 40.7, scale: 1, rotate: 5, ring: 5 },
    { id: 100, x: 50.0, y: 40.7, scale: 1, rotate: -4, ring: 5 },
    { id: 101, x: 55.6, y: 40.7, scale: 1, rotate: 3, ring: 5 },
    { id: 102, x: 61.2, y: 40.7, scale: 1, rotate: -5, ring: 5 },
    { id: 103, x: 66.9, y: 40.7, scale: 1, rotate: 4, ring: 5 },
    { id: 104, x: 72.5, y: 40.7, scale: 1, rotate: -3, ring: 5 },
    // 第 5 圈— 後方 +7
    { id: 105, x: 30.3, y: 40.7, scale: 1, rotate: 5, ring: 5, behind: true },
    { id: 106, x: 36.9, y: 40.7, scale: 1, rotate: -4, ring: 5, behind: true },
    { id: 107, x: 43.4, y: 40.7, scale: 1, rotate: 3, ring: 5, behind: true },
    { id: 108, x: 50.0, y: 40.7, scale: 1, rotate: -5, ring: 5, behind: true },
    { id: 109, x: 56.6, y: 40.7, scale: 1, rotate: 4, ring: 5, behind: true },
    { id: 110, x: 63.1, y: 40.7, scale: 1, rotate: -3, ring: 5, behind: true },
    { id: 111, x: 69.7, y: 40.7, scale: 1, rotate: 5, ring: 5, behind: true },

    // 第 6 圈— 前方 9
    { id: 112, x: 30.5, y: 47.4, scale: 1, rotate: -5, ring: 6 },
    { id: 113, x: 35.4, y: 47.4, scale: 1, rotate: 4, ring: 6 },
    { id: 114, x: 40.2, y: 47.4, scale: 1, rotate: -3, ring: 6 },
    { id: 115, x: 45.1, y: 47.4, scale: 1, rotate: 5, ring: 6 },
    { id: 116, x: 50.0, y: 47.4, scale: 1, rotate: -4, ring: 6 },
    { id: 117, x: 54.9, y: 47.4, scale: 1, rotate: 3, ring: 6 },
    { id: 118, x: 59.8, y: 47.4, scale: 1, rotate: -5, ring: 6 },
    { id: 119, x: 64.6, y: 47.4, scale: 1, rotate: 4, ring: 6 },
    { id: 120, x: 69.5, y: 47.4, scale: 1, rotate: -3, ring: 6 },
    // 第 6 圈— 後方 +7
    { id: 121, x: 32.9, y: 47.4, scale: 1, rotate: 5, ring: 6, behind: true },
    { id: 122, x: 38.6, y: 47.4, scale: 1, rotate: -4, ring: 6, behind: true },
    { id: 123, x: 44.3, y: 47.4, scale: 1, rotate: 3, ring: 6, behind: true },
    { id: 124, x: 50.0, y: 47.4, scale: 1, rotate: -5, ring: 6, behind: true },
    { id: 125, x: 55.7, y: 47.4, scale: 1, rotate: 4, ring: 6, behind: true },
    { id: 126, x: 61.4, y: 47.4, scale: 1, rotate: -3, ring: 6, behind: true },
    { id: 127, x: 67.1, y: 47.4, scale: 1, rotate: 5, ring: 6, behind: true },

    // 第 7 圈（最下層，最靠近樹幹）— 前方 6
    { id: 128, x: 33.5, y: 52.7, scale: 1, rotate: -5, ring: 7 },
    { id: 129, x: 40.1, y: 52.7, scale: 1, rotate: 4, ring: 7 },
    { id: 130, x: 46.7, y: 52.7, scale: 1, rotate: -3, ring: 7 },
    { id: 131, x: 53.3, y: 52.7, scale: 1, rotate: 5, ring: 7 },
    { id: 132, x: 59.9, y: 52.7, scale: 1, rotate: -4, ring: 7 },
    { id: 133, x: 66.5, y: 52.7, scale: 1, rotate: 3, ring: 7 },
    // 第 7 圈（最下層，最靠近樹幹）— 後方 +4
    { id: 134, x: 36.8, y: 52.7, scale: 1, rotate: 5, ring: 7, behind: true },
    { id: 135, x: 45.6, y: 52.7, scale: 1, rotate: -4, ring: 7, behind: true },
    { id: 136, x: 54.4, y: 52.7, scale: 1, rotate: 3, ring: 7, behind: true },
    { id: 137, x: 63.2, y: 52.7, scale: 1, rotate: -5, ring: 7, behind: true },
];

export const TREE_IMAGE = '/image/wishtree/tree.png';
